// Imprimir un PDF del servidor sin abrir otra pestaña (Rodrigo, 2026-10-24: «al hacer la venta en el
// punto de venta debería tirar el DTE automático»): se carga en un marco oculto y se abre el diálogo
// de impresión del navegador. Si el navegador no lo permite, se abre el PDF en otra pestaña.
export function imprimirPdf(pdf: Blob): void {
  const url = URL.createObjectURL(pdf);
  const marco = document.createElement('iframe');
  marco.setAttribute('aria-hidden', 'true');
  marco.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
  marco.src = url;
  marco.onload = () => {
    try {
      marco.contentWindow?.focus();
      marco.contentWindow?.print();
    } catch {
      window.open(url, '_blank', 'noopener');
    }
    // El diálogo de impresión ya tomó el documento: el marco se limpia después.
    window.setTimeout(() => {
      marco.remove();
      URL.revokeObjectURL(url);
    }, 60_000);
  };
  document.body.appendChild(marco);
}
